import {
  Box,
  Autocomplete,
  TextField,
  InputAdornment,
  IconButton,
} from "@mui/material";
import axios from "axios";
import { useState } from "react";
import debounce from "lodash/debounce";
import CustomKeyboard from "./keyboard";
import { api_base } from "../../env";
import CircularProgress from "@mui/material/CircularProgress";
import TagIcon from "@mui/icons-material/Tag";
import AddReactionIcon from "@mui/icons-material/AddReaction";
import Hashtags from "../hashtags/HashtagsPopup";
import GraphemeSplitter from "grapheme-splitter";

export default function InputClientUploadFiles({
  text,
  index,
  dbEditImageText,
  setImage,
  type,
  idEvent,
}) {
  const [activeIndex, setActiveIndex] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [loadingSuggestions, setLoadingSuggestions] = useState(false);

  const [openHashTags, setopenHashTags] = useState(false);
  const [indexInputHashTag, setIndexInputHashTag] = useState();
  const [keyboardOpen, setKeyboardOpen] = useState(false);

  const [currentLayout, setCurrentLayout] = useState("default");
  const fetchSuggestions = debounce(async (value) => {
    if (!value) return;
    try {
      setLoadingSuggestions(true);
      const res = await axios.get(
        `${api_base}HashTagsRoute/search?query=${value}`
      );
      setSuggestions(res.data);
    } catch (error) {
      console.error("Erreur suggestions:", error);
    } finally {
      setLoadingSuggestions(false);
    }
  }, 300);
  const handleKeyPress = (button) => {
    if (button.length === 2 && inputValue.endsWith(button)) {
      return;
    }
    switch (button) {
      case "{shift}":
        setCurrentLayout((prevLayout) =>
          prevLayout === "default" ? "shift" : "default"
        );
        break;
      case "{numbers}":
        setCurrentLayout("numbers");
        break;
      case "{default}":
        setCurrentLayout("default");
        break;
      case "{delete}":
        if (inputValue) {
          const updatedValue = inputValue.slice(0, -2); // Remove the last character
          setInputValue(updatedValue);

          if (activeIndex !== null) {
            handleTextChange(activeIndex, updatedValue);
          }
        }
        break;
      default:
        const newValue = inputValue + button;
        setInputValue(newValue);
        if (activeIndex !== null) {
          handleTextChange(activeIndex, newValue);
        }
        break;
    }
  };

  const handleToggleKeyboard = (index, text = "") => {
    if (activeIndex === index) {
      setKeyboardOpen(false);
      setActiveIndex(null);
      setSuggestions([]);
    } else {
      setSuggestions([]);
      setKeyboardOpen(true);
      setActiveIndex(index);
      setInputValue(text || "");
    }
    setTimeout(() => {
      if (document.activeElement) document.activeElement.blur();
    }, 0);
  };

  const handleCloseKeyboard = () => {
    setKeyboardOpen(false);
  };
  const onChange = (input) => {
    console.log("Keyboard Input:", input);
    if (activeIndex !== null) {
      handleTextChange(activeIndex, input);
    }
  };

  const handleTextChange = async (index, Text) => {
    const splitter = new GraphemeSplitter();
    const allowedEmojis = [
      "😊",
      "😂",
      "❤️",
      "👍",
      "🔥",
      "🎉",
      "✨",
      "🙌",
      "💖",
      "💞",
      "💍",
      "💌",
      "💋",
      "🌹",
      "💕",
      "💑",
      "🥰",
      "👫",
      "😎",
      "😜",
      "😀",
      "😃",
      "😄",
      "😁",
      "😆",
      "😅",
      "🤣",
      "😝",
      "😛",
      "🤑",
      "🤩",
      "🤓",
      "🧐",
      "😏",
      "😒",
      "😞",
      "😔",
      "😟",
      "😕",
      "😣",
      "😖",
      "😫",
      "😩",
      "🥺",
      "😢",
      "😭",
      "😤",
      "😡",
      "🤬",
      "😠",
      "😷",
      "🤒",
      "🤢",
      "🤮",
      "🥶",
      "😵",
      "😵‍💫",
      "🤯",
      "🤡",
      "👶",
      "👦",
      "👧",
      "🤗",
      "😉",
      "🥳",
      "😘",
      "😫",
      "🥺",
      "🤔",
      "😍",
      "😈",
      "👹",
      "👻",
      "🙏",
      "👑",
      "🌻",
      "🌞",
      "🌝",
      "🌹",
      "✨",
      "⭐",
      "💫",
      "🌊",
      "💦",
      "🎂",
      "👣",
      "👸",
      "👯‍♀",
      "💃",
      "🐾",
      "🎮",
      "🎻",
      "🕋",
      "⏳",
      "💎",
      "🎁",
      "🧸",
      "💞",
      "🤍",
      "🖤",
      "💜",
      "💙",
      "💛",
      "💚",
    ];

    const allowedTextRegex = /^[\p{L}\p{N}\s\p{P}\p{S}]+$/u;
    const emojiRegex = /\p{Extended_Pictographic}/u;

    const graphemes = splitter.splitGraphemes(Text);

    const newText = graphemes
      .filter(
        (char) =>
          allowedEmojis.includes(char) ||
          (allowedTextRegex.test(char) && !emojiRegex.test(char))
      )
      .join("");

    console.log(newText);
    //var newText = Text;

    if (newText.length <= 20) {
      setInputValue(newText);
      setImage((current) => {
        if (Array.isArray(current)) {
          return current.map((img, i) =>
            i === index ? { ...img, text: newText } : img
          );
        } else if (typeof current === "object" && current !== null) {
          return { ...current, text: newText };
        } else {
          return current;
        }
      });

      if (
        typeof dbEditImageText === "function" &&
        typeof index !== "undefined"
      ) {
        await dbEditImageText(index, newText);
      }
    } else {
      //alert("Text length must not exceed 20 characters, including emojis.");
    }
  };

  const addHashTages = async (text) => {
    setImage((current) => {
      if (Array.isArray(current)) {
        return current.map((img, imgIndex) =>
          imgIndex === indexInputHashTag ? { ...img, text: text } : img
        );
      } else if (typeof current === "object" && current !== null) {
        return { ...current, text: text };
      } else {
        return current;
      }
    });

    if (typeof dbEditImageText === "function") {
      await dbEditImageText(indexInputHashTag, text);
    }
  };
  return (
    <>
      {" "}
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        width="100%"
        mb={1}
      >
        <Autocomplete
          freeSolo
          fullWidth
          options={suggestions}
          getOptionLabel={(option) => option.text || ""}
          loading={loadingSuggestions}
          //inputValue={img.text || ""}
          inputValue={text || ""}
          onInputChange={(event, newInputValue, reason) => {
            handleTextChange(index, newInputValue);
            setKeyboardOpen(false);
            if (reason === "input") {
              fetchSuggestions(newInputValue);
            }
          }}
          onChange={(event, newValue) => {
            if (newValue) {
              const valueToAdd =
                typeof newValue === "string" ? newValue : newValue.text || "";
              handleTextChange(index, valueToAdd);
            }
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              placeholder="Votre Texte"
              sx={{
                width: "90%",
                background: "white",
                marginTop: "10px",
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "grey",
                    borderRadius: "15px",
                  },
                  "&:hover fieldset": {
                    borderColor: "black",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "black",
                  },
                },
              }}
              InputProps={{
                ...params.InputProps,

                onFocus: (e) => {
                  console.log("index :", index);
                  console.log("indexactiveIndex :", activeIndex);
                  console.log("activeIndex === index :", activeIndex === index);
                  console.log("keyboardOpen :", keyboardOpen);
                  console.log("etat :", keyboardOpen && activeIndex === index);
                  if (keyboardOpen && activeIndex === index) {
                    e.preventDefault();
                    e.target.blur(); 
                }},
                startAdornment: (
                  <InputAdornment position="start">
                    <IconButton
                      onClick={() => {
                        setKeyboardOpen(false);
                        setIndexInputHashTag(index);
                        setopenHashTags(true);
                      }}
                    >
                      <TagIcon />
                    </IconButton>
                  </InputAdornment>
                ),
                endAdornment: (
                  <>
                    {loadingSuggestions && (
                      <CircularProgress color="inherit" size={20} />
                    )}
                    {params.InputProps.endAdornment}

                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => {
                          handleToggleKeyboard(index, text);
                          document.activeElement.blur();
                        }}
                      >
                        <AddReactionIcon />
                      </IconButton>
                    </InputAdornment>
                  </>
                ),
              }}
            />
          )}
        />
      </Box>
      {keyboardOpen && activeIndex === index && (
        <CustomKeyboard
          inputValue={inputValue}
          onChange={onChange}
          onKeyPress={handleKeyPress}
          layoutName={currentLayout}
          closeKeyboard={handleCloseKeyboard}
          showEmojiOnly={true}
        />
      )}
      <Hashtags
        open={openHashTags}
        onClose={() => setopenHashTags(false)}
        addHashTages={addHashTages}
        type={type}
        idevent={idEvent}
      />
    </>
  );
}

export function SimpleInputTextWithKeyboard({ text, setText, type, idEvent }) {
  const [inputValue, setInputValue] = useState(text || "");
  const [keyboardOpen, setKeyboardOpen] = useState(false);
  const [currentLayout, setCurrentLayout] = useState("default");
  const [suggestions, setSuggestions] = useState([]);
  const [loadingSuggestions, setLoadingSuggestions] = useState(false);
  const [openHashTags, setOpenHashTags] = useState(false);
 console.log("idEvent :" , idEvent)
  const fetchSuggestions = debounce(async (value) => {
    if (!value) return;
    try {
      setLoadingSuggestions(true);
      const res = await axios.get(
        `${api_base}HashTagsRoute/search?query=${value}`
      );
      setSuggestions(res.data);
    } catch (error) {
      console.error("Error fetching suggestions:", error);
    } finally {
      setLoadingSuggestions(false);
    }
  }, 300);

  const handleKeyPress = (button) => {
    switch (button) {
      case "{shift}":
        setCurrentLayout((prev) => (prev === "default" ? "shift" : "default"));
        break;
      case "{numbers}":
        setCurrentLayout("numbers");
        break;
      case "{default}":
        setCurrentLayout("default");
        break;
      case "{delete}":
        const updated = inputValue.slice(0, -2);
        updateText(updated);
        break;
      default:
        updateText(inputValue + button);
        break;
    }
  };

  const updateText = (newVal) => {
    const allowedEmojis = [
      "😊",
      "😂",
      "❤️",
      "👍",
      "🔥",
      "🎉",
      "🙌",
      "💖",
      "🥰",
      "✨",
    ];
    console.log("Updated Text:", newVal);
    const allowedTextRegex = /^[\p{L}\p{N}\s\p{P}\p{S}]+$/u;
    const emojiRegex = /\p{Extended_Pictographic}/u;

    const splitter = new GraphemeSplitter();
    const graphemes = splitter.splitGraphemes(newVal);
    const cleanText = graphemes

      .filter(
        (char) =>
          allowedEmojis.includes(char) ||
          (allowedTextRegex.test(char) && !emojiRegex.test(char))
      )
      .join("");
    console.log("Graphemes:", graphemes);
    console.log("Clean Text:", cleanText);
    if (cleanText.length <= 20) {
      setInputValue(cleanText);
      setText(cleanText);
    }
  };

  const handleInputChange = (event, newVal, reason) => {
    setKeyboardOpen(false);
    if (reason === "input") {
      updateText(newVal);
      fetchSuggestions(newVal);
    }
  };

  const handleSelectSuggestion = (event, newVal) => {
    if (newVal) {
      const newText = typeof newVal === "string" ? newVal : newVal.text || "";
      updateText(newText);
    }
  };

  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        width="100%"
        mb={1}
      >
        <Autocomplete
          freeSolo
          fullWidth
          options={suggestions}
          getOptionLabel={(option) => option.text || ""}
          loading={loadingSuggestions}
          inputValue={inputValue}
          onInputChange={handleInputChange}
          onChange={handleSelectSuggestion}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Votre Texte"
              variant="outlined"
              sx={{
                width: "90%",
                background: "white",
                marginTop: "10px",
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { borderColor: "grey", borderRadius: "15px" },
                  "&:hover fieldset": { borderColor: "black" },
                  "&.Mui-focused fieldset": { borderColor: "black" },
                },
              }}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {loadingSuggestions && <CircularProgress size={20} />}
                    {params.InputProps.endAdornment}
                    <InputAdornment position="end">
                      <IconButton onClick={() => setOpenHashTags(true)}>
                        <TagIcon />
                      </IconButton>
                      <IconButton onClick={() => setKeyboardOpen(true)}>
                        <AddReactionIcon />
                      </IconButton>
                    </InputAdornment>
                  </>
                ),
              }}
            />
          )}
        />
      </Box>

      {keyboardOpen && (
        <CustomKeyboard
          inputValue={inputValue}
          onChange={setInputValue}
          onKeyPress={handleKeyPress}
          layoutName={currentLayout}
          closeKeyboard={() => setKeyboardOpen(false)}
          showEmojiOnly={true}
        />
      )}

      <Hashtags
        open={openHashTags}
        onClose={() => setOpenHashTags(false)}
        addHashTages={(val) => {
          updateText(val);
        }}
        type={type}
        idevent={idEvent}
      />
    </>
  );
}
